import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";
import {
  setNotifications,
  setNotificationCount,
} from "../../../store/slices/notificationSlice";

const useNotifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notificationList.list);
  const notificationCount = useSelector(
    (state) => state.notificationList.listCount
  );

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const countResponse = await axiosInstance.get(
          "/notificationevent/?flag=count"
        );
        const newCount = countResponse?.data?.data?.count ?? 0;
        if (newCount !== notificationCount) {
          dispatch(setNotificationCount(newCount));

          const listResponse = await axiosInstance.get(
            "/notificationevent/?read=false"
          );
          const notificationList = listResponse?.data?.results ?? [];

          if (notificationList.length > 0) {
            dispatch(setNotifications(notificationList));
          } else {
            dispatch(setNotifications([]));
          }
        }
      } catch (error) {
        console.log("Failed to fetch notifications:", error);
      }
    };

    fetchNotifications();
  }, [dispatch, notificationCount]);

  return { notifications, notificationCount };
};

export default useNotifications;
